<template>
    <div style="padding: 24px">
        <el-form  :model="formData" :style="{height: tableHeight+'px',overflowY:'auto'}"  ref="formRef" label-width="100px" size="mini">
            <div class="flex">
                <el-form-item  prop="i_ctype" label="类型">
                    <el-select v-model="formData.i_ctype" size="mini"  @change="changeCtype">
                        <el-option v-for="item in i_ctypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item  prop="i_type" label="设备类型">
                    <el-select v-model="formData.i_type" size="mini"  @change="changetype">
                        <el-option v-for="item in i_typeList" :key="item.ywid" :label="item.name" :value="item.ywid" ></el-option>
                    </el-select>
                </el-form-item>
            </div>
            <div class="yong">
                <el-form-item  label="启用字段">
                    <el-button round icon="el-icon-plus"  @click="addRow"   size="mini" ></el-button>
                </el-form-item>
                <div v-for="(item,i) in qyList"  class="dib">
                    <div class="flex a-i-f-s" >
                        <el-form-item  :prop="item.name" :label="'扩展字段'+item.name.substring(6)">
                            <el-input v-model="item.text"  size="mini" class="input" @change="qychange(item,i)"></el-input>
                        </el-form-item>
                        <el-button  icon="el-icon-remove-outline"  type="text" @click="deleteRow(item,i)"  size="mini" class="mrl10" ></el-button>
                    </div>
                </div>
            </div>
            <div class="buyong">
                <el-form-item  label="停用字段">
                </el-form-item>
                <div v-for="(item,i) in tyList" class="dib">
                    <div class="flex a-i-f-s" >
                        <el-form-item  :prop="item.name" :label="'扩展字段'+item.name.substring(6)">
                            <el-input v-model="item.text"  size="mini" class="input" @change="tychange(item,i)" ></el-input>
                        </el-form-item>
                        <el-button  icon="el-icon-circle-plus-outline"  @click="backRow(item,i)"   size="mini" type="text" ></el-button>
                    </div>
                </div>
            </div>
            <div  class="dialog-footer" style="text-align: center">
                <el-button type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">保存</el-button>
                <!--            <el-button @click="cancel" size="small">取 消</el-button>-->
            </div>
        </el-form>

    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,baseApp,file_url,baseVersion,file_root} from "@/utils/baseUrl";
    export default {
        name: "index",
        components: {},
        data() {
            return {
                tableHeight:0,
                canEdit:true,
                disabled:false,
                baseerp:'',
                file_root:'',
                formData:{
                    i_ctype:1,
                    i_type:'',
                },
                id:0,
                i_typeList:[
                    // {id:1,name:'设备'},{id:2,name:'备品备件'}
                ],
                i_ctypeList:[{id:1,name:'设备'},{id:2,name:'设备配件'}],
                numList:[],
                qyList:[],
                tyList:[],

            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.getDeviceDict(7);
            this.baseerp=baseerp;
            this.file_root=file_root;
            this.getDateYYYYMMddHHMMSS();
            this.formData.lruname=sessionStorage.getItem("lruname");
            this.formData.i_lruid=sessionStorage.getItem("userid");
            this.$nextTick(()=>{
                this.onResize();
            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-20;
                if(this.tableHeight<60)this.tableHeight=60;
            },
            deleteRow(item,i){
                item.state=-1;
                this.tyList.push(item);
                this.qyList.splice(i,1);
                this.$forceUpdate();

            },
            addRow(){
                let l=this.qyList.length+this.tyList.length;
                this.qyList.push({
                    name:'vc_def'+(l+1),
                    text:'',
                    state:1,
                    type:'new',
                });
                // this.numList.push(l);
                this.$forceUpdate();

            },
            backRow(item,i){
                item.state=1;
                this.qyList.push(item);
                this.tyList.splice(i,1);
                this.$forceUpdate();

            },
            changeCtype(){
                this.formData.i_type='';
                this.i_typeList=[];
                this.tyList=[];
                this.qyList=[];
                if(this.formData.i_ctype==1){
                    this.getDeviceDict(7);

                }else if(this.formData.i_ctype==2){
                    this.getDeviceDict(8);
                }
            },
            tychange(item,i){
                item.state=-1
            },
            qychange(item,i){
                item.state=1
            },
            changetype(){
                this.getConfigColumn()
            },
            saveForm(){
                this.$confirm('是否确认保存','提示',{
                    confirmButtonText:'继续',
                    cancelButtonText:'取消',
                    type:'warning'
                }).then(async()=>{
                    let tyarr=this.tyList.filter(t=>t.state==-1),
                        qyarr=this.qyList.filter(t=>t.state==1&&t.type!='new'),
                        qynewarr=this.qyList.filter(t=>t.type=='new'),

                        arr=tyarr.concat(qyarr);
                    qynewarr.map(n=>{
                        delete n.type
                    })
                    this.disabled=true;
                    this.saveConfigColumn(qynewarr,arr)
                }).catch(()=>{
                    this.$message({
                        type:'info',
                        message:'已取消'
                    })
                })
                // return;

            },
            async getConfigColumn(){
                let param={
                    type:this.formData.i_type,
                    ctype:this.formData.i_ctype,
                };
                let res=await API.getConfigColumn(param);
                if ( res.code == 1 ){
                    this.formData.pid=res.pid;
                    // console.log(res.data);
                    this.qyList=Object.keys(res.data).map(key=>({name:key,text:res.data[key],state:0}));
                    this.tyList=Object.keys(res.disableData).map(key=>({name:key,text:res.disableData[key],state:0}));
                    // console.log('this.numList=',this.numList)
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getDeviceDict(val){
                let param={
                    type:val,
                };
                let res=await API.getDeviceDict(param);
                if ( res.code == 1 ){
                    this.i_typeList=res.data;
                    this.formData.i_type=res.data[0].ywid;
                    this.getConfigColumn();
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async saveConfigColumn(addList,updateList){

                let param={
                    pid:this.formData.pid,
                    addList:addList,
                    updateList:updateList
                };
                // return
                let res=await API.saveConfigColumn(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message);

                    // this.$emit('close','save');
                    this.getConfigColumn();

                    this.disabled=false
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false

                }
            },

            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                this.formData.createtime=`${date.getFullYear()}-${month}-${strDate}`;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .dib{
        display: inline-block;
    }
    .flex{
        display:flex;
    }
    .yong{
        background-color: #ffe6d2;
        margin-bottom: 20px;
    }
    .buyong{
        margin-bottom: 20px;

        background-color: #f1f1f1;
    }
    .a-i-f-s{
        align-items: flex-start;
    }
    .jcsb{
        justify-content: space-between;

    }
    .el-form-item__content .el-input,.el-form-item__content .el-input-number,.el-form-item__content .el-select{
        width: 150px;
    }
    .uploadfile1{
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }

</style>